import { render, staticRenderFns } from "./newgrouper.vue?vue&type=template&id=7aaa034c"
import script from "./newgrouper.vue?vue&type=script&lang=js"
export * from "./newgrouper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports